import { render, staticRenderFns } from "./StickerGenerator.vue?vue&type=template&id=055aa986"
import script from "./StickerGenerator.vue?vue&type=script&lang=js"
export * from "./StickerGenerator.vue?vue&type=script&lang=js"
import style0 from "./StickerGenerator.vue?vue&type=style&index=0&id=055aa986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports